import React from 'react';
import Popover from '@mui/material/Popover';
import { useClintMediaQuery } from '@/utils/hooks/useClintMediaQuery';

const MobilePopover = (props: {
  children: React.ReactNode;
  anchorEl: Element | (() => Element) | null;
  paperClassName?: string;
}) => {
  const { children, anchorEl, paperClassName = '' } = props;
  const isMobile = useClintMediaQuery();

  const open = Boolean(anchorEl);

  if (!isMobile) {
    return null;
  }

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      classes={{ paper: 'mobile-paper' }}
      className="!top-16 !w-screen !left-0"
      hideBackdrop
      slotProps={{
        paper: {
          className: paperClassName,
          sx: {
            '&.mobile-paper': {
              width: '100%',
              height: '100%',
              top: '0 !important',
              left: '0 !important',
              boxShadow: 'none !important',
              maxWidth: 'none',
              maxHeight: 'none',
              borderRadius: 0,
            },
          },
        },
      }}
    >
      {children}
    </Popover>
  );
};

export default MobilePopover;
